module.exports = Object.freeze({
    CONCERN_ABOUT_THE_GROUP: 1,
    NOT_FOLOWWING_SENIOR_LINK_RULES: 2
});